import React from "react";
import { Box, Modal, IconButton } from "@mui/material";
import { X } from "lucide-react";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
  maxHeight: "90vh",
  overflow: "auto",
};

const ViewBrandModal = ({ brand, open, onClose }) => {
  if (!brand) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div className="border-b border-gray-200">
          <div className="px-6 py-4 flex items-center justify-between">
            <h2 className="text-lg font-medium text-gray-900">Brand Details</h2>
            <IconButton size="small" onClick={onClose}>
              <X size={18} />
            </IconButton>
          </div>
        </div>

        <div className="p-6">
          <div className="flex items-start gap-6">
            {/* Brand Image */}
            <div className="w-32 h-32">
              <img
                src={brand.image || require("../../../../../assets/brand.png")}
                alt={brand.name}
                className="w-full h-full rounded-lg object-cover"
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = require("../../../../../assets/brand.png");
                }}
              />
            </div>

            {/* Brand Details */}
            <div className="flex-1 space-y-4">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-medium text-gray-900">
                  {brand.name}
                </h3>
                <div className="flex items-center gap-2">
                  <span
                    className={`px-2.5 py-1 text-xs font-medium rounded-full 
                    ${
                      brand.status === "ACTIVE"
                        ? "bg-green-50 text-green-700"
                        : "bg-red-50 text-red-700"
                    }`}>
                    {brand.status}
                  </span>
                  <span
                    className={`px-2.5 py-1 text-xs font-medium rounded-full 
                    ${
                      brand.brandtype === "DOMESTIC"
                        ? "bg-blue-50 text-blue-700"
                        : "bg-orange-50 text-orange-700"
                    }`}>
                    {brand.brandtype === "DOMESTIC"
                      ? "Domestic"
                      : "International"}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-gray-500">Products</p>
                  <p className="font-medium">{brand.products_count || 0}</p>
                </div>
                <div>
                  <p className="text-gray-500">Created At</p>
                  <p className="font-medium">
                    {new Date(brand.createdAt).toLocaleDateString()}
                  </p>
                </div>
                <div>
                  <p className="text-gray-500">Last Updated</p>
                  <p className="font-medium">
                    {new Date(brand.updatedAt).toLocaleDateString()}
                  </p>
                </div>
              </div>

              {brand.description && (
                <div>
                  <p className="text-gray-500 text-sm">Description</p>
                  <p className="mt-1 text-gray-700">{brand.description}</p>
                </div>
              )}
            </div>
          </div>

          {/* Order Validation Details */}
          {brand.orderValidation?.validationType === "MOQ_MOV" && (
            <div className="mt-6 pt-6 border-t border-gray-200">
              <h4 className="text-sm font-medium text-gray-900 mb-4">
                Order Validation Rules
              </h4>
              <div className="grid grid-cols-3 gap-6">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-500">Validation Type</p>
                  <p className="font-medium text-gray-900">MOQ/MOV</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-500">
                    Minimum Order Quantity
                  </p>
                  <p className="font-medium text-gray-900">
                    {brand.orderValidation.minOrderQty || "N/A"}
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-500">Minimum Order Value</p>
                  <p className="font-medium text-gray-900">
                    ₹{brand.orderValidation.minOrderValue || "N/A"}
                  </p>
                </div>
              </div>
              <div className="mt-4 bg-purple-50 p-4 rounded-lg">
                <p className="text-sm text-purple-700">
                  <span className="font-medium">Validation Condition:</span>{" "}
                  {brand.orderValidation.validationCondition === "BOTH"
                    ? "Both MOQ and MOV conditions must be met"
                    : "Either MOQ or MOV condition must be met"}
                </p>
              </div>
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default ViewBrandModal;
